module.exports = __webpack_public_path__ + "static/media/18.4e59f7c5.jpg";